import { ErrorLogComponent } from '@cian/error-log-component';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import * as React from 'react';
import { Provider } from 'react-redux';
import { UiKitRoot } from '@cian/ui-kit';

import { TReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { PageContainer } from '../Page';
import { HeaderContainer } from '../HeaderContainer';
import { ApplicationContext } from '../../utils/applicationContext';
import { NewReviewModalContainer } from '../NewReviewModal';
import { NewAnswerModalContainer } from '../NewAnswerModal';
import { NewQuestionModalContainer } from '../NewQuestionModal';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { userAgent },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={uaToDeviceType(userAgent || undefined)}>
          <Provider store={reduxStore}>
            <HeaderContainer />
            <PageContainer />
            <NewReviewModalContainer />
            <NewAnswerModalContainer />
            <NewQuestionModalContainer />
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
